import { defineComponent as _defineComponent } from 'vue';
import { CollapseTransition } from '@ivanv/vue-collapse-transition';
import ExpandButton from '~/components/ui/CustomStoreFrontUI/ExpandButton.vue';
import { useGetDisplayOptionsClasses } from '~/composables/useGetDisplayOptionsClasses';
import BlockExpandableLinkStandardTab from '~/components/cms/custom/BlockExpandableLink/BlockExpandableLinkStandardTab.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BlockExpandableLink',
  props: {
    title: null,
    content: {
      default: function _default() {
        return [];
      }
    },
    displayOptions: {
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var isExpanded = ref(false);
    var titleRef = ref();
    var classes = useGetDisplayOptionsClasses(props.displayOptions);
    provide('isContentExpanded', isExpanded.value);
    var switchIsExpanded = function switchIsExpanded() {
      isExpanded.value = !isExpanded.value;
      if (!titleRef.value) return;
      var titleOffsetTop = titleRef.value.getBoundingClientRect().top + window.scrollY;
      window.scroll({
        top: titleOffsetTop - 100,
        behavior: 'smooth'
      });
    };
    return {
      __sfc: true,
      props: props,
      isExpanded: isExpanded,
      titleRef: titleRef,
      classes: classes,
      switchIsExpanded: switchIsExpanded,
      CollapseTransition: CollapseTransition,
      ExpandButton: ExpandButton,
      BlockExpandableLinkStandardTab: BlockExpandableLinkStandardTab
    };
  }
});